export default __webpack_public_path__ + "static/media/loader.37f1cc20.svg";